import { render, staticRenderFns } from "./AnxList.vue?vue&type=template&id=67e37bb0&scoped=true&"
import script from "./AnxList.vue?vue&type=script&lang=ts&"
export * from "./AnxList.vue?vue&type=script&lang=ts&"
import style0 from "./AnxList.vue?vue&type=style&index=0&id=67e37bb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e37bb0",
  null
  
)

export default component.exports